<template>
    <div class=" bg-round bg-fff parteners">
        <div class="container">
            <Bread class="ma-t-30"/>
            <!-- <header id="header">
                <div class="flex f-around">
                    <div class="header-li" @click="toPage('About')">SHISW</div>
                    <div class="header-li" @click="toPage('Founder')">创始人Founder</div>
                    <div class="header-li" @click="toPage('Curator')">策展团队Curator</div>
                    <div class="header-li" @click="toPage('Jury')">评审团Jury</div>
                    <div class="header-li" @click="toPage('volunteer')">志愿者团队volunteer</div>
                    <div class="header-li header-active" @click="toPage('Parteners')">合作伙伴Parteners</div>
                </div>
            </header> -->
        </div>

        <div class="container">
            <div class="box-wrap t-center v-cloak pa-b-40" id="app">
                <div class="row">
                    <div class="col-md-2 li-title  ">国际征片独家合作：</div>
                    <div class="col-md-10 row  f-center" v-if="list[0]">
                        <div class="col-md-3" v-for="(item,index) in list[0].Item" :key="index">
                            <img :src="item.Url" alt="" srcset="">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 li-title   ">国际合作机构：</div>
                    <div class="col-md-10 row  f-center" v-if="list[1]">
                        <div class="col-md-3" v-for="(item,index) in list[1].Item" :key="index">
                            <img :src="item.Url" alt="" srcset="">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2 li-title  ">中国合作机构：</div>
                    <div class="col-md-10 row f-center" v-if="list[2]">
                        <div class="col-md-3" v-for="(item,index) in list[2].Item" :key="index">
                            <img :src="item.Url" alt="" srcset="">
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-md-2 li-title  ">合作媒体：</div>
                    <div class="col-md-10 row f-center" v-if="list[3]">
                        <div class="col-md-3" v-for="(item,index) in list[3].Item" :key="index">
                            <img :src="item.Url" alt="" srcset="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .parteners{
        min-height: calc(100% - 100px - 61px - 30px);
    }
     @media (max-width:768px) {
        .box-wrap img {
            margin-top: 10px;
            max-width: 100%;
            max-height: auto;
        }
    }
    @media (min-width:768px) {
        .box-wrap img {
            max-height: 90px;
            max-width: 100%;
        }
    }

    .about-text {
        line-height: 30px;
    }

    .img-a-bg {
        width: 100%;
        height: 285px;
        background: url('../../img/merge/a1.png') no-repeat;
        background-size: cover;
        background-position: center center;
        text-align: right;
        line-height: 285px;
    }

    .img-logo {
        width: 206px;
        height: 206px;
        margin-right: 40px;
    }

    .img-person {
        width: 220px;
    }

    .li-title {
        color: #fb004d;
        font-weight: bold;
        font-size: 20px;
        padding-top: 60px;
    }



    #iframeFoot {
        margin-top: 100px;
    }

    .body-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
    }
    html{overflow-y:scroll;} 
    .col-md-3{
        margin-bottom: 30px;
        margin-top: 30px;
    }
    [v-cloak] {
        display: none;
    }
</style>
<script>
    import {getPartners} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                list:[],
                footbottom:123,
            };
        },
        created() {
            console.log("开始开发")
            this.loadData();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            },
            //获取数据
            loadData() {
                getPartners().then((res) => {
                    console.log(res);
                    this.list = res.data.Data
                });
            },
        },
    };
</script>
